import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
  tag: 'as-product-card',
  styleUrl: 'as-product-card.css',
  shadow: true,
})
export class AsProductCard {
  @Element() el: HTMLElement;

  @Prop() product?: any;
  @Prop() mode?: any = 'shopnow';
  @Prop() overlay?: any;
  @Prop() channel?: any;
  @Prop() trackevent?: any = null;
  @Prop() player?: any;
  @Prop() photoviewer?: any;
  @Prop() index?: number = 0;

  private theme?: string = 'dark';
  private quickcart?: number = 0;
  private imagesize?: string = 'small';

  componentWillLoad() {
    if(this.channel) {
      this.theme = this.channel.productTheme;
      this.quickcart = this.channel.quickCart;
      this.imagesize = this.channel.productImageSize;
    }
  }

  componentDidLoad() {
    if(this.channel) {
      var style = document.createElement( 'style' )
      style.innerHTML = `.product-card { --as-player-btn-color: ${this.channel.primaryColor.hex}; --as-player-btn-txt-color: ${this.channel.textColor.hex}; }`;
      this.el.shadowRoot.appendChild( style );
    }
    // console.log('product cart loaded', this.theme, this.quickcart, this.imagesize);
  }

  render() {
    if(this.product && this.product.id) {
      return (
        <Host>

<a class={{
  "product-card": true,
  "dark": (this.theme === 'dark'),
  "light": (this.theme === 'light'),
  "image-small": (this.imagesize === "small"),
}} href={!this.quickcart ? this.product.platformProduct.onlineStoreUrl : '#'} onClick={(e) => {
  e.preventDefault();
  this.trackevent('product_card_click', {
    productid: this.product.id,
    cardindex: this.index,
    quickcart: this.quickcart,
  }, this.player || this.photoviewer)
  if(this.quickcart) {
    this.openDetails();
  } else {
    window.location.href = this.product.platformProduct.onlineStoreUrl ;
  }
  return true;
}}>
  <img class="product" src={this.product.platformProduct.featuredImage.url} alt={this.product.platformProduct.title} />
    <div class="product-card-body">
      <div class="product-card-item-name">{this.product.platformProduct.title}</div>
      <div class="product-card-item-price">
        <span class="unit-price-label">
          {this.getPrice(this.product.platformProduct.priceRangeV2)}
        </span>
      </div>
      <div class="ctacontainer">
        <button tabindex="0" class="product-buy-now-button">Shop Now</button>
        {/* <img src="https://cdnv2.allstudio.live/icons/arrow-right-white.svg" class="buy-now-arrow" /> */}
      </div>
    </div>
  </a>

        </Host>
      );
    } else {
      return (
        <Host>
        </Host>
      );
    }
  }

  getPrice(range) {
    let finalPrice = `${this.getCurrencySymbol(range.minVariantPrice.currencyCode)} ${range.minVariantPrice.amount}`;
    if(range.minVariantPrice.amount !== range.maxVariantPrice.amount) {
      finalPrice = `${this.getCurrencySymbol(range.minVariantPrice.currencyCode)} ${range.minVariantPrice.amount} - ${this.getCurrencySymbol(range.minVariantPrice.currencyCode)} ${range.maxVariantPrice.amount}`;
    }
    return finalPrice;
  }

  getCurrencySymbol(currency) {
    var currency_symbols = {
      'USD': '$', // US Dollar
      'EUR': '€', // Euro
      'CRC': '₡', // Costa Rican Colón
      'GBP': '£', // British Pound Sterling
      'ILS': '₪', // Israeli New Sheqel
      'INR': '₹', // Indian Rupee
      'JPY': '¥', // Japanese Yen
      'KRW': '₩', // South Korean Won
      'NGN': '₦', // Nigerian Naira
      'PHP': '₱', // Philippine Peso
      'PLN': 'zł', // Polish Zloty
      'PYG': '₲', // Paraguayan Guarani
      'THB': '฿', // Thai Baht
      'UAH': '₴', // Ukrainian Hryvnia
      'VND': '₫', // Vietnamese Dong
    };
    if(currency_symbols[currency]!==undefined) {
      return currency_symbols[currency];
    }
  }

  openDetails() {
    // console.log('open overlay from product card');
    // this.player?.viewFullScreen();
    this.overlay?.open(this.product, this.channel, this.player, this.photoviewer, this.trackevent);
  }

  closeDetails() {
    this.el.shadowRoot.getElementById('product-details-popup').style.height = "0%";
  }
}
